import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import {
  digiLockerInitiateUrl,
  digiLockerFetchUrl,
  sendBeneficiaryOtpUrl,
  verifyBeneficiaryOtpUrl,
  verifyUserPanUrl,
  beneficiaryNomineeV2Url,
} from '../url';

export const initiateDigiLocker = async (mobileNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        digiLockerInitiateUrl(),
        {
          doc_type: 'AADHAAR',
          mobile_number: mobileNumber,
          sign_up_preference: 'PINLESS',
          check_account_linked: 'false',
          consent: 'Y',
          redirect_url: `${process.env.REACT_APP_BASE_URL}/beneficiary/add-gap-beneficiary`,
        },
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const fetchDigiLockerData = async (sessionId) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(digiLockerFetchUrl(sessionId), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const sendBeneficiaryOtp = async (phoneNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        sendBeneficiaryOtpUrl(),
        { phone_number: phoneNumber, privacy_policy_accept_status: true },
        getTokenHeader(token),
      )
      .then(({ data }) => next({ success: true, message: data?.message || 'OTP sent successfully' }))
      .catch((err) => next({ success: false, message: err?.response?.data?.message || 'Failed to send OTP' }));
  });
};

export const verifyUserPan = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(verifyUserPanUrl(), payload, getTokenHeader(token))
      .then(({ data }) => next(data))
      .catch((err) => next({
        error: true,
        data: {
          is_user_pan_verified: false,
          error_message: err?.response?.data?.message || 'Verification failed. Please try again.',
        },
      }));
  });
};

export const submitBeneficiaryNominee = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(beneficiaryNomineeV2Url(), payload, getTokenHeader(token))
      .then(({ data }) => next({ success: true, data }))
      .catch((err) =>
        next({
          success: false,
          message:
            err?.response?.data?.message ||
            'Submission failed. Please try again.',
        }),
      );
  });
};

export const verifyBeneficiaryOtp = async (phoneNumber, otp) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        verifyBeneficiaryOtpUrl(),
        { phone_number: phoneNumber, otp },
        getTokenHeader(token),
      )
      .then(({ data }) => next({
        success: data?.data?.is_otp_verified === true,
        message: data?.data?.is_otp_verified === true
          ? (data?.message || 'OTP verified successfully')
          : (data?.message || 'OTP does not match'),
      }))
      .catch((err) => next({ success: false, message: err?.response?.data?.message || 'Invalid OTP' }));
  });
};
